@if (isConsentShown()) {
    <div class="consent-screen">
        <div class="consent-content padding-horizontal">
            <ion-text class="consent-text">
                <p>
                    We collect analytics data to improve your experience. This includes information about how you use
                    our app, which helps us make it better. Your privacy is important to us. You can learn more about
                    our data practices in our
                    <a [href]="privacyPolicyUrl" target="_blank">Privacy Policy</a>
                    .
                </p>
            </ion-text>
            <div class="consent-buttons">
                <ion-button (click)="onAccept()" class="ion-margin-end">Accept All</ion-button>
                <ion-button (click)="onReject()">Decline All</ion-button>
            </div>
        </div>
    </div>
}
